import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/flipboard': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32V480H448V32H0zM358.4 211.2H268.8V300.8H179.2V390.4H89.6V121.6H358.4V211.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/flipboard.js
// module id = RmID
// module chunks = 144